<template>
  <div class="turneo__Experiences">
    <TurneoSlider v-for="item in data" :key="item.id" :data="item"/>
  </div>
</template>

<script setup>
  defineOptions({
    autoImportStyles: false
  });
  
  defineProps({
    data: {}
  })
</script>